import API from './api';

export const assetService = {
  // Get all assets
  getAssets: (params) => API.get('/assets', { params }),

  // Get single asset
  getAssetById: (id) => API.get(`/assets/${id}`),

  // Create new asset
  createAsset: (data) => API.post('/assets', data),

  // Update asset
  updateAsset: (id, data) => API.put(`/assets/${id}`, data),

  // Delete asset
  deleteAsset: (id) => API.delete(`/assets/${id}`),

  // Get asset statistics
  getAssetStats: () => API.get('/assets/stats/summary'),
};